export const suppressUselessWarnings = () => {
  const consoleError = console.error;
  const SUPPRESSED_ERRORS = [
    "Warning: React does not recognize the `",
    "Warning: Unknown event handler property `",
  ];

  console.error = function filterErrors(msg, ...args) {
    if (
      !SUPPRESSED_ERRORS.some(
        (entry) => typeof msg === "string" && msg.includes(entry)
      )
    ) {
      consoleError(msg, ...args);
    }
  };
};
